import React, { useEffect } from "react";

export default function ParticlesBackground() {
  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js"]',
    );

    const initParticles = () => {
      if (window.particlesJS) {
        window.particlesJS("particles-js", {
          particles: {
            number: {
              value: window.innerWidth < 1200 ? 70 : 100,
              density: { enable: true, value_area: 800 },
            },
            color: { value: "#84a3d0" },
            shape: { type: "circle" },
            opacity: {
              value: window.innerWidth < 1200 ? 0.3 : 0.8,
              random: true,
              anim: { enable: true, speed: 1, opacity_min: 0.1, sync: false },
            },
            size: {
              value: window.innerWidth < 1200 ? 0.1 : 3,
              random: true,
              anim: { enable: true, speed: 20, size_min: 0.1, sync: false },
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: "#84a3d0",
              opacity: 0.5,
              width: 1,
            },
            move: {
              enable: true,
              speed: 1,
              direction: "none",
              random: false,
              straight: false,
              out_mode: "out",
              bounce: false,
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: { enable: true, mode: "attract" },
              onclick: { enable: true, mode: "push" },
              resize: true,
            },
            modes: {
              attract: { distance: 200, duration: 0.4, speed: 1 },
            },
          },
          retina_detect: true,
        });
      }
    };

    if (existingScript) {
      // script already present
      if (window.particlesJS) initParticles();
      else
        existingScript.addEventListener("load", initParticles, { once: true });
    } else {
      // inject script
      const script = document.createElement("script");
      script.src =
        "https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js";
      script.async = true;
      script.onload = initParticles;
      document.body.appendChild(script);
    }

    return () => {
      // Cleanup particles canvas if any
      const container = document.getElementById("particles-js");
      if (container) container.innerHTML = "";
    };
  }, []);

  return (
    <div
      id="particles-js"
      className="fixed inset-0 z-0 bg-[linear-gradient(270deg,rgba(18,111,237,0.236),#fff)]"
    />
  );
}
